import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import classnames from "classnames"

import SelectBoxLabel from "../../../components/Inputs/SelectBoxLabel"
import SpinnerLoad from "../../../components/SpinnerLoad"

import styles from "./styles.css"

import {
  partnerLocality,
  partnerLocalityAreaLocals,
  partnerLocalityUfs
} from "services/state/fixedVoice/action"
import { handleDocument } from "services/utils/mask"

const CustomerInfo = ({
  formik,
  partnerLocalityUfs,
  partnerLocality,
  partnerLocalityAreaLocals,
  localitiesList,
  loading
}) => {
  const {
    values,
    errors,
    setFieldValue,
    setFieldTouched,
    touched,
    handleBlur
  } = formik
  const { ufs, areaLocals, localitiesName } = localitiesList
  const [ufCurrent, setUfCurrent] = useState(values.uf || "")

  const ufsSorted = ufs && ufs.sort()
  const areasSorted = areaLocals && areaLocals.sort()
  const localities = localitiesName && localitiesName.sort()
  const isErrorFullName = touched.assigneeName && errors.assigneeName
  const isErrorDocument = touched.assigneeDoc && errors.assigneeDoc
  const isDisabledArea = !values.uf
  const isDisabledLocalities = isDisabledArea || !values.areaLocal

  const getAreaLocals = () => {
    partnerLocalityAreaLocals(values.uf)
  }

  const getAreaLocalities = () => {
    partnerLocality(values.uf, values.areaLocal)
  }

  const resetLocationFields = () => {
    setFieldValue("uf", "")
    setFieldValue("areaLocal", "")
    setFieldValue("locality", "")
    setUfCurrent("")
  }

  const prevLoadingRef = useRef(loading)

  useEffect(() => {
    if (!ufs && !values.uf) {
      partnerLocalityUfs()
    }
  }, [ufs, partnerLocalityUfs])

  useEffect(() => {
    if (values.uf && values.uf !== ufCurrent) {
      setFieldValue("areaLocal", "")
      setFieldValue("locality", "")
      setFieldTouched("locality", "")
      setUfCurrent(values.uf)
      getAreaLocals()
    }
  }, [values.uf])

  useEffect(() => {
    if (values.areaLocal) {
      getAreaLocalities()
    }
  }, [values.areaLocal])

  useEffect(() => {
    const wasLoading = prevLoadingRef.current
    prevLoadingRef.current = loading

    if (wasLoading && !loading) {
      if (!ufs && (values.uf || values.areaLocal || values.locality)) {
        resetLocationFields()
      } else if (values.uf && !areaLocals) {
        resetLocationFields()
      } else if (values.areaLocal && !localitiesName) {
        resetLocationFields()
      }
    }
  }, [
    loading,
    ufs,
    areaLocals,
    localitiesName,
    values.uf,
    values.areaLocal,
    values.locality
  ])

  const handleInputDocument = (event) => {
    const { name, formattedValue } = handleDocument(event)
    handleChange(name, formattedValue)
  }

  const handleChange = (name, value) => {
    setFieldValue(name, value, true)

    const updatedErrors = { ...errors }
    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  if (loading) {
    return (
      <div className={styles.load_container}>
        <SpinnerLoad />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.line}>
        <div>
          <input
            id="assigneeName"
            name="assigneeName"
            type="text"
            placeholder="Nome Completo*"
            className={`${isErrorFullName && styles.focus_error}`}
            onChange={(e) => {
              handleChange(e.target.name, e.target.value)
            }}
            value={values.assigneeName}
            onBlur={handleBlur}
            tabIndex={3}
          />
          {isErrorFullName && (
            <div className={styles.error}>{errors.assigneeName}</div>
          )}
        </div>

        <div>
          <input
            id="assigneeDoc"
            name="assigneeDoc"
            type="text"
            placeholder="CPF ou CNPJ*"
            className={`${isErrorDocument && styles.focus_error}`}
            onChange={(e) => {
              handleInputDocument(e)
            }}
            value={values.assigneeDoc}
            onBlur={formik.handleBlur}
            tabIndex={4}
          />
          {isErrorDocument && (
            <div className={styles.error}>{errors.assigneeDoc}</div>
          )}
        </div>
      </div>

      <div className={classnames(styles.line, styles.addressContainer)}>
        <div className={styles.uf_style}>
          <SelectBoxLabel
            formik={formik}
            values={{
              name: "uf",
              placeholder: "UF",
              isDisabled: false
            }}
            options={ufsSorted}
            tab={5}
          />
        </div>

        <div className={styles.select_box_address}>
          <SelectBoxLabel
            formik={formik}
            values={{
              name: "areaLocal",
              placeholder: "Área local",
              isDisabled: isDisabledArea
            }}
            options={areasSorted}
            tab={6}
          />
        </div>

        <div className={styles.select_box_address}>
          <SelectBoxLabel
            formik={formik}
            values={{
              name: "locality",
              placeholder: "Localidade",
              isDisabled: isDisabledLocalities
            }}
            options={localities}
            tab={7}
          />
        </div>
      </div>
    </div>
  )
}

CustomerInfo.propTypes = {
  formik: PropTypes.object,
  partnerLocalityUfs: PropTypes.func,
  partnerLocality: PropTypes.func,
  partnerLocalityAreaLocals: PropTypes.func,
  localitiesList: PropTypes.object,
  loading: PropTypes.bool
}

const mapStateToProps = ({ newOrder }) => ({
  localitiesList: newOrder.localityResponse,
  loading: newOrder.loading
})

export default connect(mapStateToProps, {
  partnerLocalityUfs,
  partnerLocality,
  partnerLocalityAreaLocals
})(CustomerInfo)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/components/CustomerInfo.js